var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup302(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 264,
    viewBox: "0 0 153 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.7996 174.412C87.2234 174.412 94.0523 167.583 94.0523 159.159C94.0523 150.735 87.2234 143.906 78.7996 143.906C70.3757 143.906 63.5469 150.735 63.5469 159.159C63.5469 167.583 70.3757 174.412 78.7996 174.412Z",
    fill: "#A2AABF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.166 0.00114864C53.3281 0.169532 33.8098 19.5412 33.4712 43.3773C33.4681 43.5974 33.4666 45.1448 33.4668 47.1687C33.467 50.1362 34.6458 52.9821 36.7441 55.0804C38.8423 57.1788 41.6882 58.3579 44.6556 58.3582H44.6557C46.1267 58.3579 47.5832 58.0677 48.942 57.5043C50.3009 56.9408 51.5354 56.1151 52.575 55.0744C53.6146 54.0337 54.4389 52.7983 55.0009 51.4388C55.5629 50.0794 55.8515 48.6225 55.8502 47.1515C55.849 45.7748 55.8484 44.8219 55.8484 44.7634C55.8476 41.0795 56.8058 37.4589 58.6287 34.2577C60.4517 31.0566 63.0765 28.385 66.2451 26.506C69.4137 24.6269 73.0168 23.6051 76.7001 23.5409C80.3834 23.4768 84.02 24.3725 87.252 26.1401C90.4841 27.9077 93.2004 30.4862 95.1337 33.622C97.067 36.7578 98.1507 40.3428 98.2782 44.0244C98.4057 47.7061 97.5726 51.3575 95.8609 54.6195C94.1492 57.8815 91.6178 60.6418 88.5158 62.6288L88.5197 62.6335C88.5197 62.6335 72.5944 72.8858 67.7392 86.9501L67.7433 86.9511C66.8896 89.8323 66.457 92.8218 66.4589 95.8268C66.4589 97.0621 66.5316 107.87 66.672 116.643C66.7211 119.669 67.9582 122.556 70.1163 124.679C72.2744 126.801 75.1805 127.991 78.2077 127.99H78.2078C79.7289 127.99 81.2349 127.689 82.6393 127.105C84.0437 126.521 85.3187 125.664 86.3909 124.585C87.4632 123.507 88.3115 122.226 88.8871 120.818C89.4626 119.41 89.7541 117.902 89.7447 116.381C89.696 108.347 89.6696 98.9926 89.6696 98.3137C89.6696 89.6777 98.0006 81.0732 104.844 75.462C112.724 69.0005 118.395 60.195 120.673 50.2622C121.177 48.2172 121.455 46.123 121.501 44.0173C121.501 38.2101 120.352 32.4603 118.12 27.0992C115.888 21.7381 112.617 16.8716 108.496 12.7802C104.375 8.68871 99.4852 5.45317 94.1081 3.25995C88.731 1.06674 82.9731 -0.0408023 77.166 0.00114864V0.00114864Z",
    fill: "#A2AABF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8148 53.0657C44.8473 53.0653 42.0015 51.8863 39.9032 49.7879C37.8049 47.6895 36.6261 44.8436 36.6259 41.8762C36.6257 39.8523 36.6272 38.3049 36.6302 38.0848C36.7245 31.1526 38.4704 24.3427 41.723 18.2202C36.3791 25.5358 33.4407 34.3314 33.3144 43.3901C33.3114 43.6102 33.3099 45.1576 33.3101 47.1814C33.3102 50.1489 34.4891 52.9948 36.5874 55.0932C38.6857 57.1916 41.5315 58.3706 44.499 58.371C46.9374 58.37 49.3089 57.5732 51.2532 56.1016C53.1975 54.6299 54.6083 52.5638 55.2713 50.2172C53.2225 52.0544 50.5667 53.069 47.8148 53.0657V53.0657Z",
    fill: "#3F3D56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9246 23.5787C81.3552 23.7426 84.6948 24.7366 87.6566 26.4754C90.6184 28.2142 93.1139 30.6459 94.929 33.5616C96.744 36.4773 97.8243 39.79 98.077 43.2152C98.3298 46.6404 97.7475 50.0758 96.3801 53.2263C98.3579 50.9035 99.8117 48.1815 100.642 45.2459C101.473 42.3103 101.66 39.2301 101.193 36.2154C100.725 33.2006 99.6124 30.3222 97.9313 27.7763C96.2503 25.2305 94.04 23.077 91.4512 21.4628C88.8624 19.8486 85.956 18.8115 82.9302 18.4224C79.9043 18.0332 76.83 18.3011 73.917 19.2077C71.0041 20.1144 68.3208 21.6385 66.0503 23.6761C63.7797 25.7138 61.9752 28.2171 60.7598 31.0153C62.8604 28.5442 65.5006 26.5885 68.4766 25.2991C71.4526 24.0098 74.6851 23.4212 77.9246 23.5787V23.5787Z",
    fill: "#3F3D56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3668 122.697C78.3396 122.698 75.4335 121.508 73.2754 119.386C71.1173 117.263 69.8802 114.377 69.8311 111.35C69.6908 102.577 69.6181 91.7692 69.6181 90.5339C69.6161 87.5289 70.0487 84.5394 70.9024 81.6582L70.8984 81.6572C71.4025 80.211 72.0114 78.8035 72.7202 77.4458C70.5444 80.3452 68.8129 83.5527 67.5826 86.9625L67.5866 86.9635C66.7329 89.8447 66.3003 92.8342 66.3023 95.8392C66.3023 97.0744 66.3749 107.883 66.5153 116.655C66.5644 119.682 67.8015 122.568 69.9596 124.691C72.1177 126.814 75.0238 128.003 78.051 128.002C80.547 128.002 82.9756 127.192 84.9724 125.695C86.9693 124.197 88.4268 122.093 89.1264 119.697C87.0053 121.631 84.2373 122.701 81.3668 122.697V122.697Z",
    fill: "#3F3D56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4393 170.691C73.2725 169.747 71.3548 168.313 69.8373 166.501C68.3198 164.689 67.2442 162.55 66.6953 160.251C66.1464 157.952 66.1393 155.558 66.6745 153.256C67.2096 150.954 68.2725 148.808 69.7791 146.987C68.0323 148.262 66.5767 149.895 65.509 151.776C64.4413 153.656 63.7858 155.743 63.5861 157.897C63.3865 160.05 63.6471 162.222 64.3508 164.267C65.0545 166.312 66.1851 168.184 67.6676 169.759C69.1502 171.334 70.9507 172.575 72.9497 173.401C74.9487 174.227 77.1005 174.618 79.2623 174.549C81.424 174.479 83.5463 173.951 85.4882 172.998C87.4301 172.046 89.1473 170.692 90.5257 169.025C88.3757 170.596 85.8516 171.577 83.2046 171.869C80.5577 172.162 77.8803 171.755 75.4393 170.691V170.691Z",
    fill: "#3F3D56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.01411 258.953C0.754351 259.423 -0.63703 260.944 0.368901 261.834C0.721447 262.149 1.23851 262.182 1.71093 262.201C49.7919 263.978 97.8948 264.403 146.02 263.477C147.359 263.449 148.955 263.275 149.58 262.09C150.206 260.906 149.345 259.331 148.109 258.744C146.873 258.156 145.451 258.252 144.09 258.335C138.209 258.69 132.307 258.49 126.463 257.738C124.604 257.503 122.702 257.19 121.043 256.342C119.901 255.759 118.89 254.931 117.734 254.384C115.832 253.467 113.663 253.324 111.557 253.209C95.9057 252.339 80.237 252.099 64.551 252.487C56.7167 252.683 48.8878 253.036 41.0644 253.545C37.9855 253.745 34.406 253.502 31.5011 254.614C28.5961 255.726 26.3163 256.964 23.1692 257.324C16.163 258.126 8.80415 256.473 2.01411 258.953V258.953Z",
    fill: "url(#paint0_linear_102_2)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8189 237.864C19.0713 237.863 19.3213 237.913 19.5545 238.009C19.7877 238.106 19.9997 238.247 20.1782 238.425C20.3568 238.604 20.4985 238.815 20.5951 239.049C20.6918 239.282 20.7415 239.532 20.7415 239.784V256.664H16.894V239.784C16.894 239.531 16.9439 239.281 17.0407 239.048C17.1375 238.815 17.2793 238.603 17.4581 238.425C17.6369 238.246 17.8492 238.105 18.0827 238.009C18.3162 237.912 18.5664 237.863 18.8189 237.864V237.864Z",
    fill: "#A2AABF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1086 254.607H11.1382C10.4503 254.607 9.89258 255.165 9.89258 255.853V255.855C9.89258 256.543 10.4503 257.101 11.1382 257.101H27.1086C27.7965 257.101 28.3542 256.543 28.3542 255.855V255.853C28.3542 255.165 27.7965 254.607 27.1086 254.607Z",
    fill: "#A2AABF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8189 237.864C19.8813 237.864 20.7415 238.63 20.7415 239.577V254.633H16.894V239.577C16.894 238.63 17.759 237.864 18.8189 237.864V237.864Z",
    fill: "url(#paint1_linear_102_2)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1086 254.607H11.1382C10.4503 254.607 9.89258 255.165 9.89258 255.853V255.855C9.89258 256.543 10.4503 257.101 11.1382 257.101H27.1086C27.7965 257.101 28.3542 256.543 28.3542 255.855V255.853C28.3542 255.165 27.7965 254.607 27.1086 254.607Z",
    fill: "#464646"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4985 260.704C11.4656 260.704 12.2495 259.92 12.2495 258.953C12.2495 257.986 11.4656 257.202 10.4985 257.202C9.5315 257.202 8.74756 257.986 8.74756 258.953C8.74756 259.92 9.5315 260.704 10.4985 260.704Z",
    fill: "#A2AABF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9551 260.704C19.9221 260.704 20.7061 259.92 20.7061 258.953C20.7061 257.986 19.9221 257.202 18.9551 257.202C17.988 257.202 17.2041 257.986 17.2041 258.953C17.2041 259.92 17.988 260.704 18.9551 260.704Z",
    fill: "#A2AABF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4116 260.704C28.3787 260.704 29.1626 259.92 29.1626 258.953C29.1626 257.986 28.3787 257.202 27.4116 257.202C26.4446 257.202 25.6606 257.986 25.6606 258.953C25.6606 259.92 26.4446 260.704 27.4116 260.704Z",
    fill: "#A2AABF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4985 260.704C11.4656 260.704 12.2495 259.92 12.2495 258.953C12.2495 257.986 11.4656 257.202 10.4985 257.202C9.5315 257.202 8.74756 257.986 8.74756 258.953C8.74756 259.92 9.5315 260.704 10.4985 260.704Z",
    fill: "url(#paint2_linear_102_2)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4868 259.914C11.0021 259.914 11.4199 259.496 11.4199 258.981C11.4199 258.466 11.0021 258.048 10.4868 258.048C9.97146 258.048 9.55371 258.466 9.55371 258.981C9.55371 259.496 9.97146 259.914 10.4868 259.914Z",
    fill: "url(#paint3_linear_102_2)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9551 260.704C19.9221 260.704 20.7061 259.92 20.7061 258.953C20.7061 257.986 19.9221 257.202 18.9551 257.202C17.988 257.202 17.2041 257.986 17.2041 258.953C17.2041 259.92 17.988 260.704 18.9551 260.704Z",
    fill: "url(#paint4_linear_102_2)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9338 259.827C19.4453 259.827 19.8599 259.413 19.8599 258.901C19.8599 258.39 19.4453 257.975 18.9338 257.975C18.4224 257.975 18.0078 258.39 18.0078 258.901C18.0078 259.413 18.4224 259.827 18.9338 259.827Z",
    fill: "url(#paint5_linear_102_2)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4116 260.704C28.3787 260.704 29.1626 259.92 29.1626 258.953C29.1626 257.986 28.3787 257.202 27.4116 257.202C26.4446 257.202 25.6606 257.986 25.6606 258.953C25.6606 259.92 26.4446 260.704 27.4116 260.704Z",
    fill: "#464646"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3951 259.907C27.9299 259.907 28.3634 259.474 28.3634 258.939C28.3634 258.404 27.9299 257.971 27.3951 257.971C26.8603 257.971 26.4268 258.404 26.4268 258.939C26.4268 259.474 26.8603 259.907 27.3951 259.907Z",
    fill: "url(#paint6_linear_102_2)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M132.649 237.864C133.158 237.864 133.646 238.066 134.006 238.426C134.367 238.786 134.569 239.275 134.569 239.784V256.664H130.729V239.784C130.729 239.532 130.778 239.282 130.875 239.049C130.971 238.816 131.113 238.604 131.291 238.426C131.469 238.248 131.681 238.106 131.914 238.01C132.147 237.913 132.397 237.864 132.649 237.864V237.864Z",
    fill: "#A2AABF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M140.936 254.607H124.965C124.277 254.607 123.72 255.165 123.72 255.853V255.855C123.72 256.543 124.277 257.101 124.965 257.101H140.936C141.624 257.101 142.181 256.543 142.181 255.855V255.853C142.181 255.165 141.624 254.607 140.936 254.607Z",
    fill: "#A2AABF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M132.649 237.864C133.709 237.864 134.569 238.63 134.569 239.577V254.633H130.729V239.577C130.729 238.63 131.589 237.864 132.649 237.864V237.864Z",
    fill: "url(#paint7_linear_102_2)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M140.936 254.607H124.965C124.277 254.607 123.72 255.165 123.72 255.853V255.855C123.72 256.543 124.277 257.101 124.965 257.101H140.936C141.624 257.101 142.181 256.543 142.181 255.855V255.853C142.181 255.165 141.624 254.607 140.936 254.607Z",
    fill: "#464646"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M124.327 260.704C125.294 260.704 126.078 259.92 126.078 258.953C126.078 257.986 125.294 257.202 124.327 257.202C123.36 257.202 122.576 257.986 122.576 258.953C122.576 259.92 123.36 260.704 124.327 260.704Z",
    fill: "#A2AABF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M132.783 260.704C133.75 260.704 134.534 259.92 134.534 258.953C134.534 257.986 133.75 257.202 132.783 257.202C131.816 257.202 131.032 257.986 131.032 258.953C131.032 259.92 131.816 260.704 132.783 260.704Z",
    fill: "#A2AABF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M141.239 260.704C142.206 260.704 142.99 259.92 142.99 258.953C142.99 257.986 142.206 257.202 141.239 257.202C140.272 257.202 139.488 257.986 139.488 258.953C139.488 259.92 140.272 260.704 141.239 260.704Z",
    fill: "#A2AABF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M124.327 260.704C125.294 260.704 126.078 259.92 126.078 258.953C126.078 257.986 125.294 257.202 124.327 257.202C123.36 257.202 122.576 257.986 122.576 258.953C122.576 259.92 123.36 260.704 124.327 260.704Z",
    fill: "url(#paint8_linear_102_2)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M124.314 259.914C124.83 259.914 125.247 259.496 125.247 258.981C125.247 258.466 124.83 258.048 124.314 258.048C123.799 258.048 123.381 258.466 123.381 258.981C123.381 259.496 123.799 259.914 124.314 259.914Z",
    fill: "url(#paint9_linear_102_2)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M132.783 260.704C133.75 260.704 134.534 259.92 134.534 258.953C134.534 257.986 133.75 257.202 132.783 257.202C131.816 257.202 131.032 257.986 131.032 258.953C131.032 259.92 131.816 260.704 132.783 260.704Z",
    fill: "url(#paint10_linear_102_2)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M132.764 259.827C133.275 259.827 133.69 259.413 133.69 258.901C133.69 258.39 133.275 257.975 132.764 257.975C132.252 257.975 131.838 258.39 131.838 258.901C131.838 259.413 132.252 259.827 132.764 259.827Z",
    fill: "url(#paint11_linear_102_2)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M141.239 260.704C142.206 260.704 142.99 259.92 142.99 258.953C142.99 257.986 142.206 257.202 141.239 257.202C140.272 257.202 139.488 257.986 139.488 258.953C139.488 259.92 140.272 260.704 141.239 260.704Z",
    fill: "#464646"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M141.223 259.907C141.758 259.907 142.191 259.474 142.191 258.939C142.191 258.404 141.758 257.971 141.223 257.971C140.688 257.971 140.254 258.404 140.254 258.939C140.254 259.474 140.688 259.907 141.223 259.907Z",
    fill: "url(#paint12_linear_102_2)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5391 206.868H128.919V213.876H39.5391V206.868Z",
    fill: "#A2AABF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M123.562 227.52C121.336 228.126 119.08 229.036 117.799 231.092C117.472 231.589 117.255 232.149 117.16 232.735C117.066 233.322 117.097 233.922 117.251 234.496C117.992 237.055 120.89 237.662 123.362 237.965C128.246 238.538 133.198 238.905 138.118 238.435C141.824 238.063 145.765 237.086 148.123 234.223C148.999 233.18 149.606 231.932 150.144 230.651C152.494 224.789 152.729 218.321 152.964 211.987C153 211.214 153 210.438 153 209.662C152.964 206.607 148.755 205.756 147.575 208.619C146.87 210.337 146.261 211.785 146.125 212.224C144.912 215.928 144.508 220.883 142.724 224.284C141.173 227.25 139.288 226.542 136.188 226.305C131.941 225.984 127.67 226.395 123.562 227.52V227.52Z",
    fill: "#3F3D56"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M123.563 227.52C121.337 228.126 119.081 229.036 117.8 231.092C117.473 231.589 117.255 232.149 117.161 232.735C117.066 233.322 117.097 233.922 117.252 234.496C117.992 237.055 120.89 237.662 123.363 237.965C128.247 238.538 133.199 238.905 138.118 238.435C141.824 238.063 145.766 237.086 148.123 234.223C149 233.18 149.606 231.932 150.145 230.651C152.495 224.789 152.73 218.321 152.965 211.987C153 211.214 153 210.438 153 209.662C152.965 206.607 148.755 205.756 147.576 208.619C146.871 210.337 146.262 211.785 146.125 212.224C144.913 215.928 144.508 220.883 142.725 224.284C141.173 227.25 139.288 226.542 136.188 226.305C131.941 225.984 127.671 226.395 123.563 227.52V227.52Z",
    fill: "#464646"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1079 227.52C33.3336 228.126 35.5899 229.036 36.8708 231.092C37.1975 231.589 37.4152 232.149 37.5096 232.735C37.604 233.322 37.5729 233.922 37.4184 234.496C36.6781 237.055 33.7802 237.662 31.3076 237.965C26.4237 238.538 21.4716 238.905 16.5524 238.435C12.846 238.063 8.90452 237.086 6.54716 234.223C5.6705 233.18 5.06411 231.932 4.52589 230.651C2.17558 224.789 1.94055 218.321 1.70552 211.987C1.67027 211.214 1.67028 210.438 1.67028 209.662C1.70553 206.607 5.91492 205.756 7.09477 208.619C7.79986 210.337 8.40861 211.785 8.54492 212.224C9.75768 215.928 10.1619 220.883 11.9458 224.284C13.497 227.25 15.382 226.542 18.482 226.305C22.7292 225.984 26.9999 226.395 31.1079 227.52V227.52Z",
    fill: "#464646"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4634 213.653H108.332V262.895H54.4634V213.653Z",
    fill: "#A2AABF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4634 213.844H108.332V262.895H54.4634V213.844Z",
    fill: "url(#paint13_linear_102_2)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4448 206.868H128.825V213.876H39.4448V206.868Z",
    fill: "url(#paint14_linear_102_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_102_2",
    x1: 74.7749,
    y1: 228.627,
    x2: 75.0593,
    y2: 296.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#A2AABF",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A2AABF",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2AABF",
    stopOpacity: 0.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_102_2",
    x1: 14.7952,
    y1: 241.598,
    x2: 22.9531,
    y2: 252.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_102_2",
    x1: 10.7124,
    y1: 252.882,
    x2: 10.0802,
    y2: 270.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_102_2",
    x1: 10.5996,
    y1: 255.745,
    x2: 10.2635,
    y2: 265.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_102_2",
    x1: 19.1572,
    y1: 253.178,
    x2: 18.525,
    y2: 271.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_102_2",
    x1: 19.0419,
    y1: 255.85,
    x2: 18.7082,
    y2: 265.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_102_2",
    x1: 27.5008,
    y1: 255.912,
    x2: 27.1507,
    y2: 265.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_102_2",
    x1: 128.623,
    y1: 241.598,
    x2: 136.781,
    y2: 252.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_102_2",
    x1: 124.541,
    y1: 252.882,
    x2: 123.908,
    y2: 270.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_102_2",
    x1: 124.43,
    y1: 255.745,
    x2: 124.091,
    y2: 265.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_102_2",
    x1: 132.987,
    y1: 253.178,
    x2: 132.355,
    y2: 271.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_102_2",
    x1: 132.87,
    y1: 255.85,
    x2: 132.536,
    y2: 265.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_102_2",
    x1: 141.328,
    y1: 255.912,
    x2: 140.978,
    y2: 265.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_102_2",
    x1: 75.32,
    y1: 210.591,
    x2: 87.7531,
    y2: 267.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_102_2",
    x1: 84.4038,
    y1: 198.999,
    x2: 83.4567,
    y2: 238.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup302);
export default __webpack_public_path__ + "static/media/Group302.ac15b1b78d8c3faa3a095d291b7b7cff.svg";
export { ForwardRef as ReactComponent };